module.exports = __webpack_public_path__ + "static/img/6.77b3b9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shlzy/6.png
// module id = ocn1
// module chunks = 0